import type { ReactNode } from "react"

export function SettingRow({
	label,
	htmlFor,
	children
}: {
	label: string
	htmlFor?: string
	children: ReactNode
}) {
	return (
		<div className="grid grid-cols-1 gap-2 sm:grid-cols-[7rem_minmax(0,1fr)] sm:items-center sm:gap-3">
			{htmlFor ? (
				<label
					htmlFor={htmlFor}
					className="text-sm whitespace-nowrap text-text-sub"
				>
					{label}
				</label>
			) : (
				<span className="text-sm whitespace-nowrap text-text-sub">{label}</span>
			)}
			{children}
		</div>
	)
}
